import React from 'react'
import { Typography } from '@material-ui/core';

const CustomLabel = (props) =>{

    return(
        <Typography className="MuiFormLabel-root MuiInputLabel-shrink" >{props.text}</Typography>
    )
}

export default CustomLabel